import { createReducer, on } from '@ngrx/store';
import { GroupApiActions, MemberUserListActions, UserApiActions } from './member-user.actions';
import { adapter, createMemberUserFromGroup, initialstate, selectGroupMemberIdFromParent } from './member-user.state';

export const memberUserReducer = createReducer(
  initialstate,
  on(GroupApiActions.memberUsersLoaded, (state, { memberUsers }) => adapter.upsertMany(memberUsers, state)),
  on(MemberUserListActions.memberUsersDeleted, (state, { memberUser }) =>
    adapter.removeOne(selectGroupMemberIdFromParent(memberUser), state)
  ),
  on(MemberUserListActions.memberUsersAdded, (state, { group, userToAdd }) =>
    adapter.addOne(createMemberUserFromGroup(userToAdd, group), state)
  ),
  on(UserApiActions.userDeleted, (state, { user }) => {
    const ids: string[] = [];
    selectMemberUserIds(state).forEach((x: string | number) => {
      if (x.toString().includes(user.id)) {
        ids.push(x.toString());
      }
    });
    return adapter.removeMany(ids, state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectMemberUserIds = selectIds;

export const selectMemberUserEntities = selectEntities;

export const selectAllMemberUsers = selectAll;
